const orderRefundDetail = () =>
  import('@/views/main/order/refund-detail/refund-detail.vue')
export default {
  path: '/main/order/orderRefundDetail',
  name: 'orderRefundDetail',
  component: orderRefundDetail,
  children: []
}
